/* @flow */
import * as React from 'react';

const ArrowBigGrayUp = props => (
  <svg width={16} height={24} viewBox="0 0 16 24" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#848794"
      fillRule="evenodd"
      opacity={0.5}
      d="M9,22.969 L9,3.889 L14.743,9.561 C15.017,9.864 15.478,9.563 15.771,9.279 C15.923,9.131 16,8.932 16,8.732 C16,8.548 15.935,8.363 15.803,8.219 L8.53,0.234 C8.47,0.174 8.436,0.164 8.407,0.143 C8.344,0.101 8.318,0.074 8.287,0.06 C8.224,0.036 8.179,0.033 8.135,0.025 C8.093,0.017 8.053,0.001 8.01,0 C7.946,0.001 7.906,0.017 7.864,0.025 C7.819,0.034 7.775,0.036 7.733,0.053 C7.681,0.074 7.656,0.101 7.626,0.119 C7.562,0.164 7.529,0.174 7.502,0.2 C7.476,0.23 0.197,8.218 0.197,8.218 C-0.077,8.519 -0.064,8.993 0.229,9.278 C0.521,9.562 0.982,9.863 1.257,9.561 L7,3.889 L7,22.969 C7,23.383 7.598,24 8,24 C8.401,24 9,23.383 9,22.969 Z"
    />
  </svg>
);

export default ArrowBigGrayUp;



// WEBPACK FOOTER //
// ./src/assets/images/icons/arrow-big-gray-up.js